// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"dd8fbd5c5dd5d8c9dc8e","293":"a2870bdd114bed36d73c","591":"c06f215f5ff213132e4e"}[chunkId] + ".js";
};